import { render, staticRenderFns } from "./FSubAreaTable.vue?vue&type=template&id=6e48be7e&scoped=true"
import script from "./FSubAreaTable.vue?vue&type=script&lang=js"
export * from "./FSubAreaTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e48be7e",
  null
  
)

export default component.exports